import requests from '@/api/request'
import Cookie from "js-cookie";
let BASE_URL = `api`
let api = {
    pagelist: `${BASE_URL}/plan/plantrain/pagelist`,//分页产查询预案培训
    add: `${BASE_URL}/plan/plantrain/add`,//分页产查询预案培训
    update: `${BASE_URL}/plan/plantrain/update`,//修改预案培训
    get: `${BASE_URL}/plan/plantrain/get`,//修改预案培训
}
// 查询
export async function plantrainPagelistAPI(data) {
    data = {
        ...data,
        strUserGuid:localStorage.getItem('userId'),
        userRoleList:JSON.parse( localStorage.getItem('userRoleLists'))
      }
    return requests({
        url: api.pagelist,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
// 新增
export async function plantrainAdd(data) {
    return requests({
        url: api.add,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
// 修改预案培训
export async function plantrainUpdate(data) {
    return requests({
        url: api.update,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
// 详情
export async function plantrainGet(params) {
    return requests({
        url: api.get,
        method: 'get',
        params,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}